<mat-toolbar color="primary" fxLayout="row" fxLayoutAlign="start center" class="main-header">
    <div fxFlex="50">
        <img src="../../assets/Mindmilieu.png" class="logo" routerLink="/dashboard">
    </div>
    <div fxFlex="50" fxLayout="row" fxLayoutAlign="end center">
        <button mat-mini-fab color="primary" (click)="signout()" *ngIf="authenticated">
            <mat-icon>logout</mat-icon>
        </button>
    </div>
</mat-toolbar>